import React from "react";
import { Routes, Route } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import DesktopHomePage from "./components/HomePage";
import MobileHomePage from "./components/MobileHomePage";

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  return isDesktop ? children : null;
};

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 1023 });
  return isMobile ? children : null;
};

function ResponsiveHome() {
  return (
    <>
      <Desktop>
        <DesktopHomePage />
      </Desktop>
      <Mobile>
        <MobileHomePage />
      </Mobile>
    </>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<ResponsiveHome />} />
      <Route path="/project/:slug" element={<ResponsiveHome />} />
    </Routes>
  );
}

export default App;
